/*
    List of all queries (sizes) for media queries are located in the file: "media-queries.css"
    Path: src > shared > styles > media-queries.css
*/

export const isViewport2Down = 500;
export const isMobileBelowWidth = 814;
